import { create } from "zustand";
import { Store } from "./types";
import { createPackageSlice } from "./packageState";
import { createConfigSlice } from "./configState";
import { createHistorySlice } from "./historyState";
import { createChatSlice } from "./chatState";
import { createFeedbackSlice } from "./feedbackState";
import { createSearchSlice } from "./searchState";
import { createDocumentSlice } from "./documentState";

export const useStore = create<Store>()((...a) => ({
  ...createPackageSlice(...a),
  ...createConfigSlice(...a),
  ...createHistorySlice(...a),
  ...createChatSlice(...a),
  ...createFeedbackSlice(...a),
  ...createSearchSlice(...a),
  ...createDocumentSlice(...a),
}));
